import { images } from 'src/provider/config/constant'
import { Puff } from  'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import './style.scss'

export const Loader: React.FC = () => {
    return (
        <div className="loader-container">
            <div className='loader-wrapper'>
                {/* <img className="loader-logo" src={'https://uploads-ssl.webflow.com/61a252e6f32925a3af57a40f/6203ed64c0e3733b91dc2504_crendly%20logo-colored.svg' || images.LOADER_LOGO} /> */}
                <Puff 
                    color='#E2C8A1'
                    height={100} 
                    width={100} 
                />
            </div>
        </div>
    )
}